import React from 'react';
import { Descriptions } from 'antd';
import type { EmployeeInfo } from '../../../services/pw9411Api';

interface EmployeeCardProps {
  employee: EmployeeInfo;
}

const EmployeeCard: React.FC<EmployeeCardProps> = React.memo(({ employee }) => {
  return (
    <div className="pw9411-employee-card bg-blue-50 border border-blue-200 rounded p-3 mb-4">
      <Descriptions
        title="員工基本資料"
        size="small"
        column={{ xs: 1, sm: 2, md: 3 }}
        bordered={false}
      >
        <Descriptions.Item label="員工代號">
          {(employee.emp_code || '').trim()}
        </Descriptions.Item>
        <Descriptions.Item label="姓名">
          {(employee.emp_name || '').trim()}
        </Descriptions.Item>
        <Descriptions.Item label="英文姓名">
          {(employee.emp_name_en || '').trim() || '—'}
        </Descriptions.Item>
        <Descriptions.Item label="部門">
          {(employee.dept_code || '').trim() || '—'}
        </Descriptions.Item>
        <Descriptions.Item label="分機">
          {(employee.ext || '').trim() || '—'}
        </Descriptions.Item>
      </Descriptions>
    </div>
  );
});

EmployeeCard.displayName = 'EmployeeCard';

export default EmployeeCard;
